// extracted by mini-css-extract-plugin
export var $animation_name = "Index-module--$animation_name--6c716";
export var ContentWrapper = "Index-module--ContentWrapper--cc18b";
export var ContentWrapper___ageGate = "Index-module--ContentWrapper___ageGate--d0bc5";